const KEY = 'luca-buying-package-lock';

export const readPackageLock = () => {
	try {
		const raw = sessionStorage.getItem(KEY);
		return raw ? JSON.parse(raw) : null;
	} catch (err) {
		return null;
	}
};

export const writePackageLock = (draft) => {
	sessionStorage.setItem(KEY, JSON.stringify(draft));
};
